module.exports = __webpack_public_path__ + "static/media/email-icon-black.c777dcea.svg";